'use strict';
import React from 'react';
import PropTypes from "prop-types";
import classnames from 'classnames';

const Col = (props) => {
	const content = props.children ? props.children : "\u00a0";
	const className = classnames(props.className, 'o-col-' + props.size);

	return <div className={className}>{content}</div>;
};

Col.propTypes = {
	size: PropTypes.number,
	className: PropTypes.string,
	children: PropTypes.node
};
Col.defaultProps = { size: 6 };

export default Col;